import { cn } from '@/utils';
import EllipseDropDown from './EllipseDropDown';
import { TextWithNum } from '../Catalog';
import { FolderFilledIcon } from '@/components/Icons';
import { FolderItemType } from '@/service/type/Folder';
import { NavLink } from 'react-router-dom';
import React from 'react';

interface FolderItemProps {
  isDragging: boolean;
  isDroppedAbove: boolean | undefined;
  isDropped: boolean;
  isHovered: boolean;
  folder: FolderItemType;
  isChildren?: boolean;
  onClickCreateSubfolder: () => void;
  onClickRename: () => void;
  onClickDelete: () => void;
  onFolderItemClick?: () => void;
  onDownloadFolder: () => void;
}

const FolderItem: React.FC<FolderItemProps> = ({
  isDragging,
  isDroppedAbove,
  isDropped,
  isHovered,
  folder,
  isChildren,
  onClickCreateSubfolder,
  onClickRename,
  onClickDelete,
  onFolderItemClick,
  onDownloadFolder,
}) => {
  return (
    <NavLink
      to={`/folder/${folder.id}`}
      key={folder.id}
      onClick={() => {
        onFolderItemClick?.();
      }}
      className={({ isActive }) =>
        cn('flex-1 flex  justify-between items-center p-jen-spacing-8 pl-[2px] border border-transparent h-[32px]', {
          '!bg-transparent': isDragging,
          'border-0 border-t border-jen-blue': isDropped && isDroppedAbove === true,
          // 'border-0 border-t border-jen-blue': isDropped && isDroppedAbove === false,
          'border border-jen-blue bg-jen-blue-20 rounded-jen-spacing-4': isHovered,
          'text-jen-orange': isActive,
        })
      }
    >
      <div className=" flex flex-1 items-center min-w-0">
        <FolderFilledIcon className=" shrink-0" />
        <TextWithNum
          className={cn(
            ' w-[240px] text-jen-size-heading-04 h-[20px] px-jen-spacing-8 hover:bg-jen-lightest-grey-100 hover:rounded-jen-spacing-4  flex items-center ',
          )}
          name={folder.name}
          num={folder.count}
        />
      </div>

      <EllipseDropDown
        onClickCreateSubfolder={onClickCreateSubfolder}
        ifShowSubFolder={isChildren}
        isHiddenEllipseIcon={isDragging}
        onClickRename={onClickRename}
        onClickDelete={onClickDelete}
        onDownloadFolder={onDownloadFolder}
      />
    </NavLink>
  );
};

export default FolderItem;
